customElements.get("product-form") || customElements.define("product-form", class extends HTMLElement {
    constructor() {
        super(),
        this.form = this.querySelector("form"),
        this.form.querySelector("[name=id]").disabled = !1,
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this)),
        this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer"),
        this.submitButton = this.querySelector('[type="submit"]'),
        document.querySelector("cart-drawer") && this.submitButton.setAttribute("aria-haspopup", "dialog"),
        this.hideErrors = this.dataset.hideErrors === "true"        
    }
    onSubmitHandler(evt) {
          evt.preventDefault();
          if (evt.preventDefault(), this.submitButton.getAttribute("aria-disabled") === "true") 
                return;
          this.handleErrorMessage(),
          this.submitButton.setAttribute("aria-disabled", !0),
          this.submitButton.classList.add("loading"),
          this.querySelector(".loading__spinner").classList.remove("hidden");          
          let inventory_policy = this.querySelector("form").closest(".product__info-container").querySelector(".inventory_policy").value;  
          let coderun = false;
          let oldmatchqty = 0;
          let oldmatchproperties = 0;
          let proId = this.querySelector("form").closest(".product__info-container").querySelector(".quantity").dataset.id;
          let proStock = this.querySelector("form").closest(".product__info-container").querySelector('.stock-in').dataset.stock;
          let quantityPro = this.querySelector("form").closest(".product__info-container").querySelector(".quantity__input").value;
          let propertiesqty = quantityPro - proStock;
          if(inventory_policy == "continue"){
            const properties_currently_availableInput = this.querySelector("form").querySelector(".properties_currently_available");
            if (properties_currently_availableInput) { properties_currently_availableInput.remove(); }
            const properties_back_in_qtyInput = this.querySelector("form").querySelector(".properties_back_in_qty");
            if (properties_back_in_qtyInput) { properties_back_in_qtyInput.remove(); }
            if(parseInt(proStock) < parseInt(quantityPro)){
              alert('Some quantities in your cart will be adjusted as they are not valid order multiples.');
              const input = document.createElement("input");
              input.type = "hidden";
              input.name = "properties[Currently Available]";
              input.classList.add("properties_currently_available");
              input.value = (proStock > 50)?"50+":proStock;
              this.querySelector("form").appendChild(input);
              const input2 = document.createElement("input");
              input2.type = "hidden";
              input2.name = "properties[Back Order]";
              input2.classList.add("properties_back_in_qty");
              input2.value = propertiesqty;
              this.querySelector("form").appendChild(input2);
            }
            $.ajax({
              url: '/cart.js',
              type: 'GET',
              dataType: 'json',
              success: function(cart) {
                if (cart.items.length != 0) {
                  cart.items.forEach(function(item) {
                    let matchitem = true;          
                    if (item.id == proId) {
                      oldmatchqty = item.quantity;
                      matchitem = false;
                      let item_qty = item.quantity;
                      $.ajax({
                        url: '/cart/change.js',
                        type: 'POST',
                        dataType: 'json',
                        data: {
                          id: proId,
                          quantity: 0
                        },
                        success: function(cart) {
                          coderun = true;
                        },
                        error: function(error) {
                          console.log('Error removing item:', error);
                        }
                      });
                    }          
                    if (matchitem) {
                      coderun = true;
                    }
                  });
                } else {
                  coderun = true;
                }
              }
            });
          }else{            
            let proStock = this.querySelector("form").closest(".product__info-container").querySelector('.stock-in').dataset.stock;
            let quantityPro = this.querySelector("form").closest(".product__info-container").querySelector(".quantity__input").value;
            if(parseInt(proStock) < parseInt(quantityPro)){
              this.querySelector("form").closest(".product__info-container").querySelector(".quantity__input").value = (parseInt(proStock));
            }
            coderun = true;
          }
          setTimeout(() => {
            if(inventory_policy == "continue"){
              if(oldmatchqty != 0){
                this.querySelector("form").closest(".product__info-container").querySelector(".quantity__input").value = (parseInt(quantityPro) + parseInt(oldmatchqty));
                if(this.querySelector("form").closest(".product__info-container").querySelector(".properties_back_in_qty")){
                  this.querySelector("form").closest(".product__info-container").querySelector(".properties_back_in_qty").value = ((parseInt(quantityPro) + parseInt(oldmatchqty)) - parseInt(proStock));
                }else{
                  const input = document.createElement("input");
                  input.type = "hidden";
                  input.name = "properties[Currently Available]";
                  input.classList.add("properties_currently_available");
                  input.value = (parseInt(proStock) > 50)?"50+":parseInt(proStock);
                  this.querySelector("form").appendChild(input);
                  const input2 = document.createElement("input");
                  input2.type = "hidden";
                  input2.name = "properties[Back Order]";
                  input2.classList.add("properties_back_in_qty");
                  input2.value = ((parseInt(quantityPro) + parseInt(oldmatchqty)) - parseInt(proStock));
                  this.querySelector("form").appendChild(input2);
                }
              }
            }
            if (coderun) {     
              const config = fetchConfig("javascript");
              config.headers["X-Requested-With"] = "XMLHttpRequest",
              delete config.headers["Content-Type"];
              const formData = new FormData(this.form);
              this.cart && (formData.append("sections", this.cart.getSectionsToRender().map(section => section.id)),
              formData.append("sections_url", window.location.pathname),
              this.cart.setActiveElement(document.activeElement)),
              config.body = formData,
              fetch(`${routes.cart_add_url}`, config).then(response => response.json()).then(response => {
              if (response.status) {
              	publish(PUB_SUB_EVENTS.cartError, {
              		source: "product-form",
                      productVariantId: formData.get("id"),
                      errors: response.errors || response.description,
                      message: response.message
                  }),
                  this.handleErrorMessage(response.description);
                  const soldOutMessage = this.submitButton.querySelector(".sold-out-message");
                  if (!soldOutMessage)
              		return;
                  this.submitButton.setAttribute("aria-disabled", !0),
                  this.submitButton.querySelector("span").classList.add("hidden"),
                  soldOutMessage.classList.remove("hidden"),
                  this.error = !0;
                  return
                  } else if (!this.cart) {
              		window.location = window.routes.cart_url;
              			return
                      }
                  this.error || publish(PUB_SUB_EVENTS.cartUpdate, {
              		source: "product-form",
                      productVariantId: formData.get("id"),
                      cartData: response
                  }),
                  this.error = !1;
                  const quickAddModal = this.closest("quick-add-modal");
                  quickAddModal ? (document.body.addEventListener("modalClosed", () => {
                  setTimeout( () => {
              		this.cart.renderContents(response)
                  }
                  )
                  }
                  , {
              		once: !0
                  }),
                  quickAddModal.hide(!0)) : this.cart.renderContents(response)
                  }
                  ).catch(e => {
              		console.error(e)
                  }
                  ).finally( () => {
              		this.submitButton.classList.remove("loading"),
                      this.cart && this.cart.classList.contains("is-empty") && this.cart.classList.remove("is-empty"),
                      this.error || this.submitButton.removeAttribute("aria-disabled"),
                      this.querySelector(".loading__spinner").classList.add("hidden")
                  }
                  )    
              }
          }, 1700);
    }
    handleErrorMessage(errorMessage=!1) {
        this.hideErrors || (this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper"),
        this.errorMessageWrapper && (this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message"),
        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage),
        errorMessage && (this.errorMessage.textContent = errorMessage)))
    }
}
);
//# sourceMappingURL=/s/files/1/0849/3753/9874/t/6/assets/product-form.js.map?v=1720155938
